import { createMachine } from 'xstate';
import { Events, ReactivateSubscriptionContext } from './types';

const initialContext = {
  error: null,
} as ReactivateSubscriptionContext;

export const reactivateSubscription = createMachine<
  ReactivateSubscriptionContext,
  Events
>({
  id: 'reactivateSubscription',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  states: {
    idle: {
      on: {
        REACTIVATE_SUBSCRIPTION: {
          target: 'reactivateSubscription',
        },
      },
    },
    reactivateSubscription: {
      invoke: {
        src: 'reactivateSubscription',
        onDone: {
          target: 'success',
          actions: 'updateSubscription',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
